/**
 * Created by Jan on 29/06/17.
 */
const Shared = require("Sources/shared");
const utils = require("Sources/utils/utils");
const LanguageManager = require("Sources/services/language-manager");

require("Styles/pages/errors/error.scss");

$(function () {
  Shared.shouldSetUpCreditsDialog = false;
  Shared.init();

  Error404.init();
});

let Error404 = {};

((Error404) => {
  Error404.init = function () {

  };
})(Error404);



// WEBPACK FOOTER //
// ./app/js/entries/errors/404.js